import styled from 'styled-components'

const Main = styled.main`

`

export default Main